export default __webpack_public_path__ + "static/media/1211.ae218f02.png";